module.exports = __webpack_public_path__ + "assets/2c2621df42cc0821432788cd05a72eea.png";